import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/views/website/layout/main.vue'
import special from '@/views/special/layout/main.vue'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  //  官网
  {
    path: '/',
    name: '首页',
    component: layout,
    redirect: '/home',
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/website/login/login.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('@/views/website/login/register.vue')
      },
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/website/home/index.vue')
      },
      // 公司简介
      {
        path: '/company/:id',
        name: 'company',
        component: () => import('@/views/website/company/index.vue')
      },
      // 汽车三包
      {
        path: '/qcsb/:id',
        name: 'qcsb',
        component: () => import('@/views/website/qcsb/index.vue')
      },
      // 新闻
      {
        path: '/news/:id',
        name: 'news',
        component: () => import('@/views/website/news/index.vue')
      },
      // 新闻详情
      {
        path: '/details',
        name: 'details',
        component: () => import('@/views/website/details/index.vue')
      },
      // 汽车三包
      {
        path: '/ywfw/:id',
        name: 'ywfw',
        component: () => import('@/views/website/ywfw/index.vue')
      },
      // 人才招聘
      {
        path: '/recruit/:id',
        name: 'recruit',
        component: () => import('@/views/website/recruit/index.vue')
      },
      // 光影世界
      {
        path: '/shadow/:id',
        name: 'shadow',
        component: () => import('@/views/website/shadow/index.vue')
      },
      // 光影世界-图片中心
      {
        path: '/shadowDetails',
        name: 'shadowDetails',
        component: () => import('@/views/website/shadowDetails/index.vue')
      },
      // search
      {
        path: '/getSearch',
        name: 'getSearch',
        component: () => import('@/views/website/getSearch/index.vue')
      },
      // 联系我们
      {
        path: '/contact',
        name: 'contact',
        component: () => import('@/views/website/contact/index.vue')
      },
      // 投诉
      {
        path: '/complaint',
        name: 'complaint',
        component: () => import('@/views/website/complaint/index.vue')
      },
      // 投诉结果
      {
        path: '/result',
        name: 'result',
        component: () => import('@/views/website/complaint/result.vue')
      },
    ]
  },
  // 专题页面
  {
    path: '/special',
    component: special,
    redirect: '/special/home',
    children: [
      {
        path: '/special/home',
        name: 'special/home',
        component: () => import('@/views/special/home/index.vue')
      },
      {
        path: '/special/article',
        name: '/special/article',
        component: () => import('@/views/special/article/index.vue')
      },
      {
        path: '/special/details',
        name: 'special/details',
        component: () => import('@/views/special/details/index.vue')
      },
      {
        path: '/special/search',
        name: 'special/search',
        component: () => import('@/views/special/search/index.vue')
      }
    ]
  },
]

const router = new VueRouter({
  routes
})

export default router
